module.exports = __webpack_public_path__ + "img/qrcode-logo.981bfde4.png";